module.exports = __webpack_public_path__ + "static/media/webrtcb.5cf5a9e6.png";